<template>
  <div class="col-20 filtre-side-wrapper">
    <div
      v-if="activeFacets.length"
      class="filtre-side"
    >
      <div class="filtre-titre">
        Facettes actives
      </div>
      <div class="filtre-side-items">
        <template
          v-for="(facet, key) in facets"
        >
          <div
            v-for="checkedFacet in facet.checked"
            :key="checkedFacet"
            class="filtre-side-item"
          >
            <input
              type="checkbox"
              :value="checkedFacet"
              :id="checkedFacet"
              v-model="facet.checked"
              @change="$emit('updateFacets', key)"
            />
            <label
              :for="checkedFacet"
            >
              {{ checkedFacet }}
            </label>
          </div>
        </template>
      </div>
    </div>

    <template v-for="(facet, key) in facets">
      <div
        class="filtre-side"
        :key="key"
        v-if="facet.availables.filter(x => !activeFacets.includes(x.key)).length"
      >
        <div class="filtre-titre">
          {{ facet.title }}
        </div>
        <div class="filtre-side-items">
          <div
            v-for="(availableFacet, index) in facet.availables.filter(x => !activeFacets.includes(x.key))"
            :key="index"
            class="filtre-side-item"
          >
            <input
              type="checkbox"
              :value="availableFacet.key"
              :id="availableFacet.key"
              v-model="facet.checked"
              @change="$emit('updateFacets', key)"
            />
            <label :for="availableFacet.key">
              {{ availableFacet.key }} ({{ availableFacet.doc_count }})
            </label>
          </div>
          <button
            v-if="facet.availables && facet.count > facet.availables.length"
            class="grey-background"
            @click="$emit('showMoreFacet', { key: key, number: facet.number + 10 })"
          >
            Voir plus
          </button>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
export default {
  name: 'AdvancedSearchFacets',

  props: {
    facets: Object
  },

  computed: {
    activeFacets () {
      let activeFacets = []
      for (const prop in this.facets) {
        activeFacets.push(this.facets[prop].checked)
      }
      return activeFacets
    }
  }
}
</script>
